import { getChartBroker } from 'components/chart/GlobalBrokerObject';

import { useOpenPositionStoreBase } from '../openPosition/openPosition.store';

const updateOpenPositionMark = (data: {
  product_id: number;
  price: number;
  best_ask: string;
  best_bid: string;
}) => {
  getChartBroker()?.handlePLUpdate?.(data.product_id.toString(), data.price);
  useOpenPositionStoreBase.getState().actions.updateOpenPositionMark(data);
};

const updateBestBidBestAsk = (data: { best_ask: string; best_bid: string }) => {
  useOpenPositionStoreBase.getState().actions.updateBestBidBestAsk(data);
};

export { updateOpenPositionMark, updateBestBidBestAsk };
